/* eslint-disable react/prop-types */
import React, { useState } from "react"; //import the component part of React
import FadeIn from "../../common/FadeIn";
import { Col, Row, Button, Form } from "react-bootstrap";

const CouponCodeBlock = (props) => {
  const [wantsCoupon, setWantsCoupon] = useState(false);

  return (
    <FadeIn delay={250} duration={450}>
      <Row>
        <Col>
          {wantsCoupon ? (
            <div className='shadow mt-4 p-3 border'>
              {" "}
              <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId='couponCode'>
                  <Form.Label>Coupon</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='25'
                    placeholder='My-Coupon-Code'
                    value={props.couponCode}
                    onChange={(e) => props.setCouponCode(e.target.value)}
                    required
                    className='border'
                  />
                  <Form.Text className='text-muted'>
                    Coupons apply from your <strong>next</strong> full subscription charge - so any
                    proration payment this month will still be taken.
                  </Form.Text>
                </Form.Group>
              </Form>
              <Button
                variant='warning'
                size='sm'
                className='mt-2 mb-2'
                onClick={() => setWantsCoupon(false)}
              >
                Remove Coupon
              </Button>
            </div>
          ) : (
            <Button
              variant='info'
              size='sm'
              className='mt-2 mb-2'
              onClick={() => setWantsCoupon(true)}
              type='button'
            >
              Add Coupon
            </Button>
          )}
        </Col>
      </Row>
    </FadeIn>
  );
};

export default CouponCodeBlock;
